import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { LeafCollectionVarienceDailyReportListing } from './Pages'

export const LeafCollectionVarienceDailyReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={LeafCollectionVarienceDailyReportListing} />
    </Fragment>
)